import React, { useState, useEffect } from 'react';
import axios from 'axios';
import $ from 'jquery';
import 'datatables.net-dt/js/dataTables.dataTables.js';

const SignalsFromTopToken = () => {
    const BaseUrl = process.env.REACT_APP_API;
    const [cryptoData, setCryptoData] = useState([]);

    useEffect(() => {
        const fetchData = () => {
            axios.get(`${BaseUrl}/cryptosignals`)
                .then((response) => {
                    setCryptoData(response.data);
                })
                .catch((error) => {
                    console.error('Error fetching crypto data:', error);
                });
        };

        fetchData();

        const interval = setInterval(fetchData, 60000);

        return () => clearInterval(interval);
    }, [BaseUrl]);
    useEffect(() => {
        if (cryptoData.length > 0) {
          const table = $('#dataTable').DataTable({
            destroy: true,
            pageLength: 10,
          });
          return () => {
            table.destroy();
          };
        }
      }, [cryptoData]);

    return (
        
        <div className="card basic-data-table">
            <div className="alert alert-warning mt-3" role="alert">
                    Disclaimer: These signals, generated by multiple indicators, are for guidance and educational purposes only. Do not trade solely based on them.
                </div>
                <div className="table-responsive">
            <table className="table bordered-table mb-0" id="dataTable" data-page-length={10}>
                <thead className="thead-dark">
                    <tr>
                        <th scope="col">Symbol</th>
                        <th scope="col">Price</th>
                        <th scope="col">
                            1 DAY 
                            </th>
                        <th scope="col">
                            1 HOUR
                           
                        </th>
                        <th scope="col">VOLUME24H</th>
                        <th scope="col">CHANGE24H</th>
                        <th scope="col">DAY CHANGE</th>
                        <th scope="col">MARKETCAP</th>
                    </tr>
                </thead>
                <tbody>
                    {cryptoData.map((coin, index) => (
                        <tr key={index}>
                            <td>
                                <img src={`https://www.cryptocompare.com${coin.Image}`} 
                                    alt={coin.symbol} width="30" height="30" className="me-2" />
                                {coin.symbol}
                            </td>
                            <td>{coin.price}</td>
                            <td>
                            <span
                                className={`px-10 rounded-pill fw-semibold text-white text-xs ${
                                coin.Signal1D === "Buy"
                                    ? "bg-info"
                                    : coin.Signal1D === "Sell"
                                    ? "bg-warning"
                                    : coin.Signal1D === "Strong Sell"
                                    ? "bg-danger"
                                    : coin.Signal1D === "Strong Buy"
                                    ? "bg-success"
                                    : "bg-secondary"
                                }`}
                            >
                                {coin.Signal1D}
                            </span>
                            </td>

                            <td>
                                <span
                                    className={`px-10 rounded-pill fw-semibold text-white text-xs ${
                                        coin.Signal1H === "Buy"
                                            ? "bg-info"
                                            : coin.Signal1H === "Sell"
                                            ? "bg-warning"
                                            : coin.Signal1H === "Strong Sell"
                                            ? "bg-danger"
                                            : coin.Signal1H === "Strong Buy"
                                            ? "bg-success"
                                            : "bg-secondary"
                                    }`}
                                >
                                    {coin.Signal1H}
                                </span>
                            </td>

                            <td>{coin.Volume24H}</td>
                            <td>
                            {(() => {
                                const changeValue = parseFloat(coin.Change24H.replace("$", "").trim());

                                return (
                                <span
                                    className={`px-16 py-6 rounded-pill fw-semibold text-xs ${
                                    changeValue >= 0
                                        ? "bg-success-focus text-success-600"
                                        : "bg-danger-focus text-danger-600"
                                    }`}
                                >
                                    <i
                                    className={
                                        changeValue >= 0 ? "ri-arrow-up-s-fill" : "ri-arrow-down-s-fill"
                                    }
                                    />
                                    {coin.Change24H}
                                </span>
                                );
                            })()}
                            </td>
                            <td>
                            {(() => {
                                const changeValue = parseFloat(coin.ChangeDay.replace("$", "").trim());

                                return (
                                <span
                                    className={`px-16 py-6 rounded-pill fw-semibold text-xs ${
                                    changeValue >= 0
                                        ? "bg-success-focus text-success-600"
                                        : "bg-danger-focus text-danger-600"
                                    }`}
                                >
                                    <i
                                    className={
                                        changeValue >= 0 ? "ri-arrow-up-s-fill" : "ri-arrow-down-s-fill"
                                    }
                                    />
                                    {coin.ChangeDay}
                                </span>
                                );
                            })()}
                            </td>
                            <td>{coin.MarketCap}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            </div> 
        </div>
    );
};

export default SignalsFromTopToken;